module.exports = __webpack_public_path__ + "img/communication18.89d77ddd.png";